import { factory, getResponseCamelization } from '@repo-level/core-front';
import type { IConfigContextData } from 'contexts/config/helpers';
import type { CMSApiBase } from './base';
import { buildCmsUrl, getResponseCMS } from './base';

export interface IConfigAPI extends CMSApiBase, IConfigContextData {}

export const fetchConfig = factory(
  (r) => (lang: string) =>
    r<IConfigAPI>(
      'get',
      buildCmsUrl({
        path: 'config',
        lang,
        additionalParams: { populate: 'deep' },
      }),
      undefined,
      { transformResponse: [getResponseCamelization(), getResponseCMS] }
    )
);
